/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { filmographyCreditSchema } from '../person-credit-schema';
import { personPhotoSchema } from '../person-photo-schema';
import { personSchema } from '../person-schema';

export const publicPersonDetailSchema = z.object({
  person: personSchema,
  photos: z.array(personPhotoSchema),
  credits: z.array(filmographyCreditSchema),
});

export type IPublicPersonDetail = z.infer<typeof publicPersonDetailSchema>;

export const getPublicPersonBySlugResponseSchema = createApiResponseSchema(
  publicPersonDetailSchema,
) as import('zod').ZodSchema<IAPI<IPublicPersonDetail>>;

export type IGetPublicPersonBySlugResponse = IAPI<IPublicPersonDetail>;
